<div class="main-container">
  <form [formGroup]="deviceForm" novalidate>
    <!-- Component Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Device Details</span>
      </div>

      <div class="page-info">
        <div class="header">UIN:</div>
        {{ uid }}
      </div>
      <div class="page-info">
        <div class="header">IMEI:</div>
        <app-common-search
          [initialSearchValue]="deviceForm?.get('search')?.value"
          [placeHolder]="'Search By IMEI and Press Enter'"
          (searchSubmit)="onSearch($event)"
        ></app-common-search>
      </div>

      <!-- Redirect Button -->
      <div class="button-group">
        @if (FotaViewPermission) {
          <button class="primary-button" (click)="redirectToFOTA()">
            FOTA <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
        @if (otaViewPermission) {
          <button class="primary-button" (click)="redirectToOTA()">
            OTA <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="kpi-section">
      <!-- Ignition On/Off -->
      <div class="kpi-card kpi-gradient-blue" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content">Ignition On/Off</span>
          <span class="kpi-value">
            {{ ignition === 1 ? 'ON' : ignition === 0 ? 'OFF' : '--' }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/ignition-on-off.png"
            alt="power-button"
          />
        </div>
      </div>

      <!-- Mains On/Off -->
      <div class="kpi-card kpi-gradient-purple" tabindex="0">
        <div class="kpi-details">
          <span class="kpi-content">Mains On/Off</span>
          <span class="kpi-value">
            {{ mains }}
            {{ mains ? (mains > 6 ? 'ON' : mains < 6 ? 'OFF' : '--') : '--' }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/mains-on-off.png"
            alt="mains-on-off"
          />
        </div>
      </div>

      @if (projectName === 'Sampark') {
        <!-- Emergency On/Off -->
        <div class="kpi-card kpi-gradient-pink" tabindex="0">
          <div class="kpi-details">
            <span class="kpi-content">Emergency On/Off</span>
            <span class="kpi-value">
              {{ emergency === 1 ? 'ON' : emergency === 0 ? 'OFF' : '--' }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              loading="lazy"
              src="../../assets/emergency.png"
              alt="emergency"
            />
          </div>
        </div>

        <!-- Tamper Open/Close -->
        <div class="kpi-card kpi-gradient-orange" tabindex="0">
          <div class="kpi-details">
            <span class="kpi-content">Tamper Open/Close</span>
            <span class="kpi-value">
              {{
                tamper === 'O'
                  ? 'OPEN'
                  : tamper === 'C'
                    ? 'CLOSE'
                    : tamper === 'W'
                      ? 'Wire Cut'
                      : tamper === 'R'
                        ? 'Reconnected'
                        : '--'
              }}
            </span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/tamper.png" alt="tamper" />
          </div>
        </div>

        <!-- ACC Calibration On/Off -->
        <div class="kpi-card kpi-gradient-green" tabindex="0">
          <div class="kpi-details">
            <span class="kpi-content">ACC Calibration On/Of</span>
            <span class="kpi-value">
              {{ calib === 1 ? 'ON' : calib === 0 ? 'OFF' : '--' }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              loading="lazy"
              src="../../assets/manometer.png"
              alt="manometer"
            />
          </div>
        </div>

        <!-- Wire Cut -->
        <div class="kpi-card kpi-gradient-yellow" tabindex="0">
          <div class="kpi-details">
            <span class="kpi-content">Wire Cut</span>
            <span class="kpi-value">
              {{ wirecut === 1 ? 'YES' : wirecut === 0 ? 'NO' : '--' }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              loading="lazy"
              src="../../assets/broken-wire.png"
              alt="broken-wire"
            />
          </div>
        </div>
      }
    </div>

    <div class="row">
      <!-- Device Details -->
      <div
        [ngClass]="
          projectName === 'Sampark'
            ? 'col-lg-3 col-sm-12'
            : projectName === 'LCT-A4G'
              ? 'col-lg-6 col-sm-12'
              : 'col-lg-4 col-sm-12'
        "
      >
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Device Details</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">IMEI Number</div>
                      <div class="value">
                        {{ deviceCurrentState?.imei || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">ICCID Number</div>
                      <div class="value">
                        {{ deviceCurrentState?.iccid || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">UIN No</div>
                      <div class="value">
                        {{ deviceCurrentState?.uin || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">VIN No</div>
                      <div class="value">
                        {{ deviceCurrentState?.vin || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                @if (projectName === 'Sampark') {
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">AEPL Firmware Ver.</div>
                        <div class="value">
                          {{ deviceCurrentState?.deviceFirmware || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                }
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Firmware Source</div>
                      <div class="value">
                        {{ deviceCurrentState?.firmwareSource || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                @if (projectName === 'LCT-A4G') {
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">Customer IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.customerIP || '--' }} :
                          {{ deviceCurrentState?.customerPort || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">AEPL IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.aeplIP || '--' }} :
                          {{ deviceCurrentState?.aeplPort || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                }
                <!-- <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Last Login Date & Time</div>
                      <div class="value"> -->
                <!-- Commented for Future Use need to discuss with VnV Team -->
                <!-- {{
                          deviceDetails?.loggedIn
                            ? (deviceDetails?.loggedIn
                              | date: 'dd MMM yyyy | hh:mm:ss a')
                            : '--'
                        }} -->
                <!-- {{
                          latestLoginTime
                            ? (latestLoginTime
                              | date: 'dd MMM yyyy | hh:mm:ss a')
                            : '--'
                        }}
                      </div>
                    </div>
                  </td> 
                 </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- IP Details -->
      @if (projectName === 'Sampark') {
        <div
          [ngClass]="
            projectName === 'Sampark'
              ? 'col-lg-3 col-sm-12'
              : 'col-lg-4 col-sm-12'
          "
        >
          <div class="component-container">
            <!-- Component Header Section -->
            <div class="component-header">
              <h6 class="component-title">IP Details</h6>
            </div>
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>
            <!-- Component Body Section -->
            <div class="component-body">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">CHTP IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.chtp || '--' }} :
                          {{ deviceCurrentState?.port1 || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">CIP1 IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.cip1 || '--' }} :
                          {{ deviceCurrentState?.port2 || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">CIP2 IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.cip2 || '--' }} :
                          {{ deviceCurrentState?.port3 || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">CIP3 IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.cip3 || '--' }} :
                          {{ deviceCurrentState?.port4 || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">CIP4 IP</div>
                        <div class="value">
                          {{ deviceCurrentState?.cip4 || '--' }} :
                          {{ deviceCurrentState?.port5 || '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">CIP5 IP</div>
                      <div class="value">
                        {{ deviceCurrentState?.cip5 || '--' }} :
                        {{ deviceCurrentState?.port6 || '--' }}
                      </div>
                    </div>
                  </td>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
      <!-- GPS Details -->
      <div
        [ngClass]="
          projectName === 'Sampark'
            ? 'col-lg-3 col-sm-12'
            : projectName === 'LCT-A4G'
              ? 'col-lg-6 col-sm-12'
              : 'col-lg-4 col-sm-12'
        "
      >
        <div class="component-container">
          <div class="component-header">
            <h6 class="component-title">GPS and GSM Details</h6>
            <div class="component-actions">
              <button
                type="button"
                matTooltip="Track Device"
                matTooltipPosition="below"
                class="primary-button"
                [disabled]="deviceDataLogin.length === 0"
                (click)="trackLocation()"
              >
                <mat-icon class="btn-icon">directions</mat-icon>
              </button>
              <button
                matTooltip="View Location"
                matTooltipPosition="below"
                class="primary-button"
                [disabled]="deviceDataLogin.length === 0"
                (click)="
                  getLocation(
                    deviceCurrentState?.lat,
                    deviceCurrentState?.longitude
                  )
                "
              >
                <mat-icon class="btn-icon">location_on</mat-icon>
              </button>
            </div>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Latitude</div>
                      <div class="value">
                        {{ deviceCurrentState?.lat || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Latitude Dir.</div>
                      <div class="value">
                        {{ deviceCurrentState?.latDir || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Longitude</div>
                      <div class="value">
                        {{ deviceCurrentState?.longitude || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Longitude Dir.</div>
                      <div class="value">
                        {{ deviceCurrentState?.longDir || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Network Type</div>
                      <div class="value">
                        {{ deviceCurrentState?.network || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">CSQ</div>
                      <div class="value">
                        {{ deviceCurrentState?.csq || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Operator Name</div>
                      <div class="value">
                        {{ deviceCurrentState?.operatorName || '--' }}
                      </div>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <td>
                    <div class="table-cell">
                      <div class="header">Registration Status</div>
                      <div class="value">
                        {{ deviceCurrentState?.REG || '--' }}
                      </div>
                    </div>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Accelerometer Details -->
      @if (projectName === 'Sampark') {
        <div class="col-lg-3 col-sm-12">
          <div class="component-container">
            <!-- Component Header Section -->
            <div class="component-header">
              <h6 class="component-title">Accelerometer Details</h6>
            </div>
            <!-- Separator between Header and Body -->
            <div class="component-separator"></div>

            <!-- table-responsive -->
            <div class="component-body">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">Angle Static:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[3] : '--' }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="table-cell">
                        <div class="header">Angle Motion:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[7] : '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">Static X Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[0] : '--' }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="table-cell">
                        <div class="header">Motion X Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[4] : '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">Static Y Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[1] : '--' }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="table-cell">
                        <div class="header">Motion Y Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[5] : '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="table-cell">
                        <div class="header">Static Z Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[2] : '--' }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="table-cell">
                        <div class="header">Motion Z Axis:</div>
                        <div class="value">
                          {{ accel_data?.length > 0 ? accel_data[6] : '--' }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Last 50 Login Packets</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            [disabled]="loginPacketArray.length === 0"
            (click)="downloadLoginPacketData()"
          >
            Export <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>UIN No.</th>
              <th>IMEI No.</th>
              <th>ICCID.</th>
              <th>Ignition</th>
              <th>Date & Time</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (loginPacketArray.length > 0) {
            <tbody>
              @for (sample of loginPacketArray; track sample) {
                <tr>
                  <td>{{ sample.uid }}</td>
                  <td>{{ sample.imei }}</td>
                  <td>{{ sample.iccid }}</td>
                  <td>{{ sample.ignition }}</td>
                  <td>
                    {{ sample.createdAt | date: 'dd MMM yyyy | hh:mm:ss a' }}
                  </td>
                  <td>
                    <div class="action-buttons">
                      <button
                        class="primary-button view-button"
                        (click)="
                          viewLoginPacketDetails(sample.data['login and HP'])
                        "
                      >
                        <mat-icon class="btn-icon">visibility</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (loginPacketArray.length === 0) {
            <tbody>
              <tr>
                <td colspan="7">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-footer">
        @if (loginPacketArray.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalPages"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>

  <div class="custom-container">
    <!-- Login Packet Details -->
    <div class="custom-modal custom-modal-m" id="loginPacketDetails">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Login Packet Details</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="component-body">
                <table>
                  @for (data of selectedLoginPacket; track $index) {
                    <tbody>
                      <tr>
                        @for (item of data; track $index) {
                          <td>
                            <div class="table-cell">
                              <div class="header">{{ item.key }} :</div>
                              <div class="value">
                                {{ item.value }}
                              </div>
                            </div>
                          </td>
                        }
                      </tr>
                    </tbody>
                  }
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
